import BookingPaths from './booking-paths';

export default BookingPaths;
